import Base from "../base";

export default class NegocioServices extends Base {
    static endpointUrl = "empresas/rubros/"
}